// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box_06":"box_06-3-2rjZLv","clearfix":"clearfix-sS2WWhtn"};